import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'

const api = '/api/rep/'
const get = axios.get
const post = axios.post

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const RelatedInvOpts = createAsyncThunk('inv-related-opts', (_, thunkAPI) =>
  handleRequest(get(`${api}inv-related-opts`), thunkAPI)
)

export const StudentPaymentRep = createAsyncThunk('std-payment', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}student-payments`, data), thunkAPI)
)

export const PrintStdPayments = createAsyncThunk('std-payment-prt', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}std-payment-print`, data), thunkAPI)
)

export const StudentPaymentExcel = createAsyncThunk(
  'std-payment-excel',
  async (formData: FormData) => {
    const response = await axios.post('/api/rep/std-payment-excel', formData, {
      responseType: 'blob', // ← MUST be here (3rd argument)
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'StudentPayments.xlsx'
    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const OrgAy = createAsyncThunk('org-academic-years', (_, thunkAPI) =>
  handleRequest(get(`${api}org-academic-years`), thunkAPI)
)

export const orgPaymentRep = createAsyncThunk('org-payment', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}org-payments`, data), thunkAPI)
)

export const PrintOrgPayments = createAsyncThunk('org-payment-print', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}org-payment-print`, data), thunkAPI)
)

export const OrgPaymentExcel = createAsyncThunk('org-payment-excel', async (formData: FormData) => {
  const response = await axios.post(`${api}org-payment-excel`, formData, {
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'OrganizationPayments.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

export const TransOpts = createAsyncThunk('org-payment', (type: string, thunkAPI) =>
  handleRequest(get(`/api/ac-reps/trans-opts/$${type}`), thunkAPI)
)

export const TransRep = createAsyncThunk('org-payment', (data: {}, thunkAPI) =>
  handleRequest(post('/api/ac-reps/trans-rep', data), thunkAPI)
)

export const TransPrt = createAsyncThunk('trans-prt', (data: {}, thunkAPI) =>
  handleRequest(post('/api/ac-reps/trans-prt', data), thunkAPI)
)

type ReportState = {}

const initialState: ReportState = {}

export const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    reset: () => initialState,
  },
})

export const {reset} = reportSlice.actions
export default reportSlice.reducer
